import classNames from 'classnames';

const styles = {
  component: (classNames(
    'flex',
    'justify-between',
    'gap-2 md:gap-6',
    '!py-8',
  )),
  buttonContainer: (isLast: boolean = false) => (classNames(
    'flex',
    'items-center',
    {
      'w-full': !isLast,
      'w-auto': isLast,
    },
  )),

};

export default styles;
